import { faBriefcase } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { useCurrentUserId } from "src/store/AuthStore";

type ClaimCaseButtonProps = {
  onClick: (userId: string) => void;
  disabled?: boolean;
  loading?: boolean;
};

export const ClaimCaseButton: React.FC<ClaimCaseButtonProps> = ({
  onClick,
  disabled,
  loading = false,
}) => {
  const currentUserId = useCurrentUserId();

  if (!currentUserId) return null;

  return (
    <Button
      disabled={disabled || loading}
      iconLeft={faBriefcase}
      loading={loading}
      size="sm"
      variant="secondary"
      onClick={() => onClick(currentUserId)}
    >
      Claim case
    </Button>
  );
};
